interface DateRangeToggleProps {
  range: string
  onRangeChange: (range: string) => void
}

const RANGES = [
  { value: "7d", label: "7 days" },
  { value: "30d", label: "30 days" },
  { value: "90d", label: "90 days" },
  { value: "all", label: "All" },
]

export function DateRangeToggle({
  range,
  onRangeChange,
}: DateRangeToggleProps) {
  return (
    <div
      className="flex gap-1 rounded-xl p-1"
      style={{ background: "var(--fig-range-bg)" }}
    >
      {RANGES.map(({ value, label }) => (
        <button
          key={value}
          className="range-btn flex-1 rounded-lg py-2"
          onClick={() => onRangeChange(value)}
          style={
            range === value
              ? {
                  background: "var(--fig-range-active-bg)",
                  color: "var(--fig-text-active)",
                  boxShadow: "var(--fig-range-active-shadow)",
                  fontSize: 13,
                  fontWeight: 600,
                }
              : {
                  background: "transparent",
                  color: "var(--fig-text-inactive)",
                  fontSize: 13,
                  fontWeight: 500,
                }
          }
        >
          {label}
        </button>
      ))}
    </div>
  )
}
